import styled, { keyframes } from 'styled-components';

export const ChatSingleBlock = styled.div`
  position: relative;
`;

export const ChatSingleHeader = styled.div`
  border-bottom: 1px solid #f1f5f9;
  border-top: 1px solid #f1f5f9;
  padding: 17px 12px 12px;
  display: flex;

  @media (max-width: 558px) {
    padding: 12px;
  }

  @media (max-width: 396px) {
    padding: 10px 8px;
  }
`;
export const ChatSingleHeaderItem = styled.div`
  position: relative;
  display: flex;
  margin-right: 14px;
  &:last-child {
    margin-right: 0;
  }

  @media (max-width: 558px) {
    margin-right: 10px;
  }

  @media (max-width: 396px) {
    margin-right: 8px;
  }
`;
export const ChatSingleHeaderIcon = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;

  @media (max-width: 396px) {
    width: 28px;
    height: 28px;
  }
`;
export const ChatSingleHeaderItemNotification = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: white;
  box-shadow: 0px 4px 4px 0px #00000040;
  font-weight: 500;
  font-size: 10px;
  color: #e63946;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -6px;
  right: -6px;

  @media (max-width: 396px) {
    width: 14px;
    height: 14px;
    font-size: 9px;
    top: -5px;
    right: -5px;
  }
`;
export const ChatSingleContent = styled.div`
  margin-top: 20px;
  padding-bottom: 100px;
  height: 314px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }
`;
export const ChatSingleItemLeft = styled.div`
  display: flex;
  margin-bottom: 12px;
  padding: 0 16px;
  &:last-child {
    /* margin-bottom: 0; */
  }
`;
export const ChatSingleItemLeftContent = styled.div`
  margin-left: 8px;
  gap: 5px;
  display: flex;
  flex-direction: column;
`;
export const ChatSingleItemLeftName = styled.h5`
  font-weight: 600;
  font-size: 12px;
  color: #0f172b;
`;
export const ChatSingleItemLeftActions = styled.div`
  display: flex;
  padding-left: 8px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
`;
export const ChatSingleItemLeftMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 9px;

  /* &:hover ${ChatSingleItemLeftActions} {
    opacity: 1;
    pointer-events: auto;
  } */
`;
export const ChatSingleItemLeftActionsEmoji = styled.img``;
export const ChatSingleItemLeftActionsReply = styled.img``;
export const ChatSingleItemLeftActionsOption = styled.img``;
export const ChatSingleItemLeftTime = styled.div`
  font-weight: 400;
  font-size: 10px;
  line-height: 15px;
  color: #62748e;
  margin-top: 2px;
`;
export const ChatSingleItemLeftMessageText = styled.div`
  width: 387px;
  border-radius: 14px;
  background-color: #f1f5f9;
  box-shadow: 0px 1px 3px 0px #0000001a;
  padding: 10px;
  font-weight: 400;
  font-size: 12px;
  line-height: 19.5px;
  color: #0f172b;
  overflow-wrap: anywhere;
  &.type-text {
    width: 54px;
    height: 36px;
    padding: 8px;
    line-height: normal;
    text-align: center;
    background-color: #f1f5f9 !important;
    --_g: no-repeat radial-gradient(circle closest-side, #000 85%, #0000);
    background:
      var(--_g) 0% 50%,
      var(--_g) 50% 50%,
      var(--_g) 100% 50%;

    background-size: calc(200% / 3) 18%;
    animation: l3 1.4s infinite ease-in-out;
  }

  @keyframes l3 {
    20% {
      background-position:
        0% 40%,
        50% 50%,
        100% 50%;
    }
    40% {
      background-position:
        0% 60%,
        50% 40%,
        100% 50%;
    }
    60% {
      background-position:
        0% 50%,
        50% 60%,
        100% 40%;
    }
    80% {
      background-position:
        0% 50%,
        50% 50%,
        100% 60%;
    }
  }

  &.status-new {
    background-color: #eff6ff;
    color: #2d6cdf;
    box-shadow: 0px 1px 3px 2px #0000001a;
  }

  @media (max-width: 558px) {
    width: 220px;
  }
  @media (max-width: 396px) {
    width: 160px;
  }
  @media (max-width: 341px) {
    width: 130px;
  }
`;
export const ChatSingleItemRight = styled.div`
  display: flex;
  margin-bottom: 12px;
  padding: 0 16px;
  justify-content: end;
  &:last-child {
    margin-bottom: 0;
  }
  &.type-text-right {
    width: 368px;
  }
  @media (max-width: 396px) {
    &.type-text-right {
      width: 330px;
    }
  }
  @media (max-width: 341px) {
    &.type-text-right {
      width: 290px;
    }
  }
`;
export const ChatSingleItemRightContent = styled.div`
  margin-right: 29px;
  margin-left: 8px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
export const ChatSingleItemRightName = styled.div`
  font-weight: 600;
  font-size: 12px;
  color: #0f172b;
`;
export const ChatSingleItemRightMessage = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;
  gap: 6px;
`;
export const ChatSingleItemRightMessageText = styled.div`
  width: 337px;
  border-radius: 14px;
  background-color: #2d6cdf;
  box-shadow: 0px 1px 3px 0px #0000001a;
  padding: 10px;
  font-weight: 400;
  font-size: 12px;
  line-height: 19.5px;
  color: #fff;
  overflow-wrap: anywhere;
  &.type-text {
    width: 54px;
    height: 36px;
    padding: 8px;
    line-height: normal;
    text-align: center;
    background-color: #2d6cdf !important;
    --_g: no-repeat radial-gradient(circle closest-side, #fff 85%, #0000);
    background:
      var(--_g) 0% 50%,
      var(--_g) 50% 50%,
      var(--_g) 100% 50%;

    background-size: calc(200% / 3) 18%;
    animation: l3 1.4s infinite ease-in-out;
  }

  @keyframes l3 {
    20% {
      background-position:
        0% 40%,
        50% 50%,
        100% 50%;
    }
    40% {
      background-position:
        0% 60%,
        50% 40%,
        100% 50%;
    }
    60% {
      background-position:
        0% 50%,
        50% 60%,
        100% 40%;
    }
    80% {
      background-position:
        0% 50%,
        50% 50%,
        100% 60%;
    }
  }
  @media (max-width: 558px) {
    width: 220px;
  }
  @media (max-width: 396px) {
    width: 160px;
  }
  @media (max-width: 341px) {
    width: 130px;
  }
`;
export const ChatSingleItemRightTime = styled.div`
  font-weight: 400;
  font-size: 10px;
  line-height: 15px;
  color: #62748e;
  margin-top: 2px;
  display: flex;
  justify-content: end;
`;
export const ChatSingleItemRightNameSpan = styled.span`
  color: #6c757d;
`;
export const ChatSingleItemRightTimeStatus = styled.img`
  margin-left: 6px;
`;
export const ChatSingleItemLeftTimeBlock = styled.div`
  display: flex;
  align-items: center;
`;
export const ChatSingleItemLeftTimeStatusNew = styled.div`
  height: 14px;
  background: #e63946;
  font-weight: 500;
  font-size: 9px;
  color: white;
  border-radius: 16px;
  padding: 1px 4px;
  margin-top: 2px;
  margin-left: 6px;
`;
export const ChatInputContainer = styled.div`
  background: #f8fafc;
  border-top: 1px solid #f1f5f9;
  padding: 12px;
  position: absolute;
  bottom: 0;
  width: 100%;
  /* &.disabled {
    background: #f8fafc80;
    opacity: 0.1;
    pointer-events: none;
  } */
`;
export const ChatInputContainerFlex = styled.div`
  display: flex;
  align-items: center;
`;
export const ChatInputContainerActions = styled.div`
  display: flex;
  align-items: center;
`;
export const ActionsAttachButton = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: white;
  border: 1px solid #0000001a;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  cursor: pointer;
  position: relative;
  transition:
    background-color 0.2s ease,
    transform 0.1s ease;

  &:hover {
    background-color: #f8fafc;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
export const AttachButtonIcon = styled.img``;
export const EmojiButtonIcon = styled.img``;
export const SubjectInput = styled.input`
  background: #f3f3f5;
  outline: none;
  border: none;
  border-radius: 8px;
  height: 36px;
  padding: 9px;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;

  &::placeholder {
    color: #94a3b8;
  }
`;

export const ChatInput = styled.textarea`
  background: #f3f3f5;
  outline: none;
  border: none;
  border-radius: 8px;
  min-height: 36px;
  resize: none;
  padding: 9px;
  flex: 1;
  &::-webkit-scrollbar {
    display: none;
  }
`;
export const SendButton = styled.div`
  width: 36px;
  height: 36px;
  background: linear-gradient(80.29deg, #2972e2 27.61%, #214882 115.98%);
  box-shadow: 0px 4px 6px -1px #0000001a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  cursor: pointer;

  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
export const SendButtonIcon = styled.img``;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const SendButtonSpinner = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
`;
export const ChatSingleReplay = styled.div`
  display: flex;
  align-items: center;
  padding-left: 16px;
`;
export const ReplayBlock = styled.div`
  margin-left: 12px;
  border-top: 1px solid #d4d8dd33;
  position: relative;
  flex: 1;
`;
export const ReplayBlockTitle = styled.h4`
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #212529;
`;
export const ReplayBlockText = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #6c757d;
`;
export const ReplayBlockClose = styled.img`
  position: absolute;
  right: 34px;
  top: 55%;
  transform: translateY(-50%);
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }

  @media (max-width: 341px) {
    right: 12px;
  }
`;

export const EmojiPickerWrapper = styled.div`
  position: absolute;
  bottom: 70px;
  left: 12px;
  z-index: 1000;
  box-shadow: 0px 10px 25px -5px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  overflow: hidden;
`;

export const FilePreviewContainer = styled.div`
  padding: 12px;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  border-top: 1px solid #e2e8f0;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-height: 140px;
  overflow-y: auto;
  position: absolute;
  bottom: 56px;
  width: 100%;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);
  animation: slideUp 0.2s ease-out;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #94a3b8;
  }
`;

export const FilePreviewItem = styled.div`
  display: flex;
  align-items: center;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 12px;
  padding-right: 32px;
  gap: 10px;
  max-width: 100%;
  position: relative;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  }
`;

export const FilePreviewIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: ${(props) => {
    switch (props.$fileType) {
      case 'image':
        return 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
      case 'video':
        return 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)';
      case 'audio':
        return 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)';
      default:
        return 'linear-gradient(135deg, #2972e2 28.85%, #214882 100%)';
    }
  }};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.2) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  }
`;

export const FilePreviewThumbnail = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
  border: 1px solid #e2e8f0;
`;

export const FilePreviewInfo = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FilePreviewName = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #0f172b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
`;

export const FilePreviewSize = styled.div`
  font-size: 11px;
  color: #64748b;
  font-weight: 500;
`;

export const FilePreviewRemove = styled.button`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #f1f5f9;
  border: 2px solid white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  z-index: 10;

  &:hover {
    background: #e63946;
    transform: rotate(90deg) scale(1.1);
    box-shadow: 0 3px 8px rgba(230, 57, 70, 0.4);
  }

  &:active {
    transform: rotate(90deg) scale(0.95);
  }

  &::before {
    content: '×';
    font-size: 16px;
    font-weight: 700;
    color: #62748e;
    transition: color 0.2s ease;
    line-height: 1;
  }

  &:hover::before {
    color: white;
  }

  &:focus {
    outline: 2px solid #2972e2;
    outline-offset: 2px;
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

// Attachment Renderer Styles
export const AttachmentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const AttachmentImageLink = styled.a`
  display: block;
  text-decoration: none;
`;

export const AttachmentImage = styled.img`
  max-width: ${(props) => (props.$isSticker ? '150px' : '280px')};
  max-height: ${(props) => (props.$isSticker ? '150px' : '280px')};
  border-radius: 8px;
  cursor: pointer;
  object-fit: cover;
  display: block;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
`;

export const AttachmentVideo = styled.video`
  max-width: 280px;
  max-height: 280px;
  border-radius: 8px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
`;

export const AttachmentAudio = styled.audio`
  width: 240px;
  border-radius: 20px;
`;

export const AttachmentFileLink = styled.a`
  display: inline-flex;
  align-items: center;
  padding: 10px 14px;
  background-color: ${(props) =>
    props.$isMyMessage ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.05)'};
  border-radius: 8px;
  text-decoration: none;
  color: ${(props) => (props.$isMyMessage ? '#fff' : 'inherit')};
  max-width: 260px;
  transition: background-color 0.2s;
  cursor: pointer;

  &:hover {
    background-color: ${(props) =>
      props.$isMyMessage ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.08)'};
  }
`;

export const AttachmentFileIcon = styled.span`
  margin-right: 10px;
  font-size: 18px;
`;

export const AttachmentFileInfo = styled.div`
  overflow: hidden;
`;

export const AttachmentFileName = styled.div`
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AttachmentFileSize = styled.div`
  font-size: 11px;
  opacity: 0.8;
  margin-top: 2px;
`;

export const AttachmentFallbackLink = styled.a`
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  background-color: ${(props) =>
    props.$isMyMessage ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.05)'};
  border-radius: 6px;
  text-decoration: none;
  color: ${(props) => (props.$isMyMessage ? '#fff' : '#2d6cdf')};
  font-size: 13px;
`;

export const AttachmentFallbackIcon = styled.span`
  margin-right: 8px;
`;

export const AttachmentWrapper = styled.div`
  max-width: ${(props) => (props.$isMyMessage ? '337px' : '387px')};
  width: fit-content;
`;

export const ContactCard = styled.div`
  background: ${(props) => (props.$isMyMessage ? '#f0f7ff' : '#ffffff')};
  border: 1px solid ${(props) => (props.$isMyMessage ? '#d4e5ff' : '#e5e7eb')};
  border-radius: 8px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 200px;
  max-width: 300px;
`;

export const ContactIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2b7fff 0%, #1d3557 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  font-weight: 600;
  flex-shrink: 0;
`;

export const ContactInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ContactName = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #0f172b;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ContactPhone = styled.div`
  font-size: 12px;
  color: #64748b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LoadingSpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const LoadingSpinner = styled.div`
  width: 18px;
  height: 18px;
  border: 2px solid #e5e7eb;
  border-top-color: #9ca3af;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const ClickableAttachmentLink = styled(AttachmentImageLink)`
  cursor: pointer;
`;

export const ClickableFileLink = styled(AttachmentFileLink)`
  cursor: pointer;
`;
export const LoadingSkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  animation: fadeIn 0.3s ease-in;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const SkeletonMessageLeft = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const SkeletonMessageRight = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  justify-content: flex-end;
`;

export const SkeletonAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(90deg, #f1f5f9 0%, #e2e8f0 50%, #f1f5f9 100%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

export const SkeletonMessageBubble = styled.div`
  height: ${(props) => props.$height || '48px'};
  width: ${(props) => props.$width || '280px'};
  border-radius: 14px;
  background: linear-gradient(90deg, #f1f5f9 0%, #e2e8f0 50%, #f1f5f9 100%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  &.right {
    background: linear-gradient(90deg, #dbeafe 0%, #bfdbfe 50%, #dbeafe 100%);
    background-size: 200% 100%;
  }

  @media (max-width: 558px) {
    width: ${(props) => (props.$width === '280px' ? '200px' : props.$width)};
  }

  @media (max-width: 396px) {
    width: ${(props) => (props.$width === '280px' ? '160px' : props.$width)};
  }
`;

export const LoadingStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 40px 20px;
`;

export const LoadingSpinnerLarge = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid #f1f5f9;
  border-top-color: #2972e2;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: 16px;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const LoadingText = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  animation: pulse 1.5s ease-in-out infinite;

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
`;
